export default __webpack_public_path__ + "static/media/huibuh-lp-grafik-01.71df3dbe.jpg";